import React from 'react';
import { useNavigate } from 'react-router-dom';
import Brand_Logo_Orange from '../../utils/assets/png/Brand-logo-white.png';
import { isMobile } from '../../utils/ScreenSizeHelper';

function BrandLogoOrange() {
  const navigate = useNavigate();
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          height: '40px', // 👈 control border height
          marginRight: '10px',
          marginLeft: '15px',
          cursor: 'pointer',
        }}
        onClick={() => {
          navigate('/');
          window.location.reload();
        }}
      >
        <img
          src={Brand_Logo_Orange}
          width='200px'
          alt='SingleCombo Logo'
          loading='eager'
          onError={(e) => {
            console.warn('Logo failed to load, retrying...');
            e.target.onerror = null;
            e.target.src = Brand_Logo_Orange + `?v=${Date.now()}`; // force reload
          }}
        />
      </div>
    </>
  );
}

export default BrandLogoOrange;
